import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, switchMap, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { CookieService } from './cookie.service';
import { IamService } from './iam.service';
import { LoadingService } from './loading.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const cookies = inject(CookieService);
  const iamService = inject(IamService);
  const loading = inject(LoadingService);
  const isPnRequest =
    request.url.startsWith(environment.baseUrl) || request.url.startsWith(environment.baseUrlV2);
  const isAuthRequest = request.url === `${environment.baseUrl}/auth`;
  let preparedRequest = request;

  if (isPnRequest) {
    const token = cookies.read('x-iam-token') ?? cookies.read('iamToken') ?? 'auth';
    preparedRequest = request.clone({
      setHeaders: isAuthRequest ? {} : { Authorization: token },
      setParams: { apikey: environment.apiKey },
    });
  }

  loading.begin();

  return next(preparedRequest).pipe(
    catchError((error: unknown) => {
      if (
        isPnRequest &&
        !isAuthRequest &&
        error instanceof HttpErrorResponse &&
        (error.status === 401 || error.status === 403)
      ) {
        if (preparedRequest.headers.get('Authorization') === cookies.read('x-iam-token')) {
          cookies.remove('x-iam-token');
        }

        return iamService.getToken().pipe(
          switchMap((token) => next(preparedRequest.clone({ setHeaders: { Authorization: token } }))),
        );
      }

      return throwError(() => error);
    }),
    finalize(() => loading.end()),
  );
};